import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { TESTIMONIALS } from "../content";

const Card = ({ t }) => (
  <div
    className="glass rounded-3xl p-7 w-[330px] sm:w-[380px] flex-shrink-0 hover:neon-violet transition-shadow duration-500"
    data-testid={`testimonial-${t.initials}`}
  >
    <div className="flex items-center gap-1 text-[#27C6FF]">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} size={14} fill="currentColor" stroke="none" />
      ))}
    </div>
    <p className="mt-5 text-[#F5F3FF] text-sm md:text-base leading-relaxed font-body">
      “{t.text}”
    </p>
    <div className="mt-6 flex items-center gap-3">
      <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#7A2BFF] to-[#27C6FF] flex items-center justify-center font-display font-bold text-white text-sm shadow-[0_0_18px_rgba(122,43,255,0.5)]">
        {t.initials}
      </div>
      <div>
        <div className="text-white font-heading font-semibold text-sm">
          {t.name}
        </div>
        <div className="text-[#CFAEFF] text-xs">{t.role}</div>
      </div>
    </div>
  </div>
);

export default function Testimonials() {
  // Duplicate the list to create seamless marquee loop
  const loop = [...TESTIMONIALS, ...TESTIMONIALS];
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative section-pad overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <div className="text-[#27C6FF] uppercase tracking-[0.3em] text-xs mb-5 font-heading">
            Client Stories
          </div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05]">
            Real transformations.
            <br />
            <span className="gradient-text">Real, lasting change.</span>
          </h2>
        </motion.div>
      </div>

      <div className="mt-14 relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#140326] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#140326] to-transparent z-10" />

        <div className="flex w-max marquee-track gap-6 px-5">
          {loop.map((t, i) => (
            <Card key={`${t.initials}-${i}`} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
}
